/* DiscoverAppDetails.tsx generated by @compiled/babel-plugin v0.29.1 */
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["as", "style"],
  _excluded2 = ["as", "style"];
import { forwardRef } from 'react';
import { ax, ix, CC, CS } from "@compiled/react/runtime";
const _4 = "._1tkem8rl{min-height:calc(100vh - 168px)}";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import OpenIcon from '@atlaskit/icon/glyph/open';
import { Link, SpinnerMask } from '@atlassian/amkt-common';
import { LinkClickedEvent, MarketplaceAnalyticsContext, TabClickedEvent, useAnalyticsEvents } from '@atlassian/mpac-analytics';
import { AppListing, AppListingPageSkeleton, AppListingTab, useAppListingByKey, useGetAppDetailsFromSearch } from '@atlassian/mpac-app-listing';
import { useFeatureFlags, useStatsig } from '@atlassian/mpac-feature-flags';
import { BreadcrumbsItem } from '@atlassian/mpac-navigation';
import { NotFound as AetherNotFound, useGetGeoIPDetails } from '@atlassian/mpac-primitives';
import { AppDeployment, BillingSystem } from '@atlassian/mpac-types';
import { AtlassianProductHostingType, MarketplaceAppPaymentModel, MarketplaceLocation } from '@atlassian/mpac-types/graphql-gateway-types';
import { useHistory, useQueryParams } from '@atlassian/mpac-ui';
import { hooks } from '@atlassian/mpac-utils';
import capitalize from 'lodash/capitalize';
import React, { useEffect, useState } from 'react';
import { ANALYTICS_EVENT_CONTAINER_EMCEE_OVERVIEW_TAB, ANALYTICS_EVENT_CONTAINER_NAV_BAR, ANALYTICS_SUBJECT_ID_DISCOVER_APP_LISTING, ANALYTICS_SUBJECT_ID_EMCEE_APP_LISTING_TAB, ANALYTICS_SUBJECT_ID_VIEW_MORE_ON_MARKETPLACE_LINK } from '../../../../analytics/Events';
import getSPI from '../../../../services/SPI';
import { AppListingPageTask } from '../../../../telemetry/tasks';
import { getApplicationConfigForEnv } from '../../../../utils/common-utils';
import { useAlgoliaConfig, useEnvironment } from '../../../AppContext';
import { AppInstallLocation, getAppInstallConfigForEnv, useInstallationLock, useMarketplaceAppInstall } from '../../../AppInstallDialog';
import { useCurrentUser } from '../../../AppInstallDialog/hooks/useCurrentUser';
import HeaderInjection from '../../../AppListing/HeaderInjection';
import useEmceeLinks from '../../../hooks/useEmceeLinks';
import NotFound from '../../../NotFound';
import CloudMigrationTrialMessage from './components/CloudMigrationTrialMessage';
import { useInstallPermission, useMarketplaceAppDetails } from './hooks';
import { getAppDeploymentType, getInstallableAddon, mapAppListingPaymentModel } from './utils';
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
const _3 = "._y3gn1h6o{text-align:center}";
const _2 = "._1e0c1ule{display:block}";
const _ = "._otyra5zd{margin-bottom:var(--ds-space-600)}";
const {
  usePrevious
} = hooks;
export const ViewMoreOnMarketplaceLink = forwardRef((_ref, __cmplr) => {
  let {
      as: C = Link,
      style: __cmpls
    } = _ref,
    __cmplp = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_, _2, _3]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_otyra5zd _1e0c1ule _y3gn1h6o", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  ViewMoreOnMarketplaceLink.displayName = 'ViewMoreOnMarketplaceLink';
}
const NotFoundContainer = forwardRef((_ref2, __cmplr) => {
  let {
      as: C = "div",
      style: __cmpls
    } = _ref2,
    __cmplp = _objectWithoutProperties(_ref2, _excluded2);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_4]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_1tkem8rl", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  NotFoundContainer.displayName = 'NotFoundContainer';
}
export const NotFoundComponent = _ref3 => {
  let {
    showAetherAppListingPage,
    history
  } = _ref3;
  return showAetherAppListingPage ? /*#__PURE__*/_jsx(NotFoundContainer, {
    children: /*#__PURE__*/_jsx(AetherNotFound, {})
  }) : /*#__PURE__*/_jsx(NotFound, {
    history: history
  });
};

// TODO modify component to remove complexity -- Fix me
// eslint-disable-next-line max-lines-per-function, complexity -- Fix me
export function DiscoverAppDetails(props) {
  var _appListingResult$mar, _props$hostPricing$re, _props$hostPricing$re2, _props$hostPricing$re3, _marketplaceApp$cloud, _marketplaceApp$cloud2;
  const fireAnalyticsEvent = useAnalyticsEvents();
  const {
    enableEmceeAetherExperience,
    enableAetherAppListingPage
  } = useStatsig();
  const isAetherExp = enableEmceeAetherExperience();
  const showAetherAppListingPage = enableAetherAppListingPage();
  const {
    appListing
  } = useEmceeLinks();
  const environment = useEnvironment();
  const applicationConfig = getApplicationConfigForEnv(environment);
  const currentUser = useCurrentUser();
  const appListingUser = {
    isMpacAdmin: false,
    isLoggedIn: !!currentUser,
    avatarUrl: currentUser === null || currentUser === void 0 ? void 0 : currentUser.avatarUrl,
    userId: currentUser === null || currentUser === void 0 ? void 0 : currentUser.atlassianAccountId
  };
  const {
    installDialogOpen: installDialogOpenInitially,
    requestDialogOpen: requestDialogOpenInitially
  } = useQueryParams();
  const history = useHistory();
  const {
    enableDeprecatedInstallationsGQL,
    enableReactivateForgeAppFromEmcee,
    enableReactivateForgeAppFromEmceeForHAMS
  } = useFeatureFlags();
  const [selectedTab, setSelectedTab] = useState(AppListingTab.Overview);
  useEffect(() => {
    /* this should only run once on mount, and before the useAppListingByKey */
    AppListingPageTask.start();
  }, [] /* this effect must not have dependencies */);
  const {
    data: appListingResult,
    loading: appListingPending
  } = useAppListingByKey({
    appKey: props.appKey,
    location: MarketplaceLocation.InProduct,
    showOnlyPublic: true
  });
  const marketplaceApp = appListingResult === null || appListingResult === void 0 ? void 0 : appListingResult.marketplaceAppByKey;
  const editions = appListingResult === null || appListingResult === void 0 ? void 0 : (_appListingResult$mar = appListingResult.marketplaceStore) === null || _appListingResult$mar === void 0 ? void 0 : _appListingResult$mar.editionsByAppKey;
  const algoliaConfig = useAlgoliaConfig();
  const appDetailsFromSearchResponse = useGetAppDetailsFromSearch({
    appKey: props.appKey,
    algoliaConfig
  });
  const {
    installationState
  } = useInstallationLock();
  const shouldEnableReactivateForgeAppFromEmcee = enableReactivateForgeAppFromEmcee && ((_props$hostPricing$re = props.hostPricing.result) === null || _props$hostPricing$re === void 0 ? void 0 : _props$hostPricing$re.billingSystem) === BillingSystem.CCP || enableReactivateForgeAppFromEmceeForHAMS && ((_props$hostPricing$re2 = props.hostPricing.result) === null || _props$hostPricing$re2 === void 0 ? void 0 : _props$hostPricing$re2.billingSystem) === BillingSystem.HAMS;
  const hostCmtEnabled = Boolean((_props$hostPricing$re3 = props.hostPricing.result) === null || _props$hostPricing$re3 === void 0 ? void 0 : _props$hostPricing$re3.hostCmtEnabled);
  const {
    result: appDetailsResult,
    pending: appDetailsPending
  } = useMarketplaceAppDetails({
    appKey: props.appKey,
    fetchInstalledApp: !props.installedApp,
    contextId: props.selectedContext.id,
    deploymentType: marketplaceApp ? getAppDeploymentType(marketplaceApp) : undefined,
    marketplaceApp,
    flags: {
      enableReactivateForgeAppFromEmcee: shouldEnableReactivateForgeAppFromEmcee,
      enableDeprecatedInstallationsGQL
    },
    hostCmtEnabled
  });
  const {
    countryCode
  } = useGetGeoIPDetails();
  const vendorSupportTicketUrl = marketplaceApp ? (marketplaceApp === null || marketplaceApp === void 0 ? void 0 : marketplaceApp.supportTicketSystemUrl) || (marketplaceApp === null || marketplaceApp === void 0 ? void 0 : marketplaceApp.issueTrackerUrl) : '';
  const {
    installerElement,
    installAppByInstallableIdentifier
  } = useMarketplaceAppInstall(getSPI(), getAppInstallConfigForEnv(environment), AppInstallLocation.EmbeddedMarketplaceAppListing, vendorSupportTicketUrl, {
    countryCode
  });
  const appVersion = marketplaceApp === null || marketplaceApp === void 0 ? void 0 : (_marketplaceApp$cloud = marketplaceApp.cloudAppVersions.edges) === null || _marketplaceApp$cloud === void 0 ? void 0 : (_marketplaceApp$cloud2 = _marketplaceApp$cloud[0]) === null || _marketplaceApp$cloud2 === void 0 ? void 0 : _marketplaceApp$cloud2.node;
  const appDeployment = appVersion === null || appVersion === void 0 ? void 0 : appVersion.deployment;
  const paymentModel = mapAppListingPaymentModel(appVersion === null || appVersion === void 0 ? void 0 : appVersion.paymentModel);
  const isConnectApp = marketplaceApp ? getAppDeploymentType(marketplaceApp) === AppDeployment.CONNECT : false;
  const isEcosystemCloudApp = marketplaceApp ? getAppDeploymentType(marketplaceApp) === AppDeployment.ECOSYSTEM_CLOUD : false;
  const marketplaceAppLink = props.links.appDetails.expand({
    appKey: props.appKey
  });
  const hasInstallPermission = useInstallPermission({
    appKey: props.appKey,
    isPermissionCheckNeeded: isEcosystemCloudApp || isConnectApp,
    installPermissionResult: appDetailsResult === null || appDetailsResult === void 0 ? void 0 : appDetailsResult.installPermission
  });
  const ecosystemCloudAppId = appDeployment === null || appDeployment === void 0 ? void 0 : appDeployment.cloudAppId;
  const installedApp = props.installedApp || (appDetailsResult === null || appDetailsResult === void 0 ? void 0 : appDetailsResult.installedApp);
  const installationInProgressAppKey = installationState.installationInProgressAppKey;

  // event handlers
  const handleTabSelect = newTab => {
    var _marketplaceApp$partn;
    setSelectedTab(newTab);
    fireAnalyticsEvent({
      eventType: TabClickedEvent,
      actionSubjectId: ANALYTICS_SUBJECT_ID_EMCEE_APP_LISTING_TAB,
      source: ANALYTICS_EVENT_CONTAINER_NAV_BAR,
      attributes: _objectSpread({
        label: capitalize(newTab),
        partnerId: marketplaceApp === null || marketplaceApp === void 0 ? void 0 : (_marketplaceApp$partn = marketplaceApp.partner) === null || _marketplaceApp$partn === void 0 ? void 0 : _marketplaceApp$partn.id,
        appId: marketplaceApp === null || marketplaceApp === void 0 ? void 0 : marketplaceApp.appId,
        appListingTabKey: newTab
      }, analyticsContextAttributes)
    });
  };
  const openInstallDialog = () => {
    installAppByInstallableIdentifier(getInstallableAddon(appDeployment, props.appKey), {
      flags: {
        show: flag => props.addFlag(flag),
        dismiss: key => props.removeFlag(key)
      }
    });
  };
  const handleBreadcrumbsItemClick = e => {
    e.preventDefault();
    history.push({
      pathname: appListing.getRelative({
        appKey: props.appKey
      })
    });
  };
  const analyticsContextAttributes = {
    appKey: props.appKey,
    isEcosystemCloudApp,
    paymentModel: paymentModel === MarketplaceAppPaymentModel.Free ? 'free' : 'paid'
  };
  const handleViewMoreOnMarketplaceLinkClick = () => {
    fireAnalyticsEvent({
      eventType: LinkClickedEvent,
      actionSubjectId: ANALYTICS_SUBJECT_ID_VIEW_MORE_ON_MARKETPLACE_LINK,
      source: ANALYTICS_EVENT_CONTAINER_EMCEE_OVERVIEW_TAB,
      attributes: _objectSpread({}, analyticsContextAttributes)
    });
  };
  const getSpinnerState = () => {
    if (appListingPending) {
      return true;
    }
    if (marketplaceApp && appDetailsPending) {
      return true;
    }
    return false;
  };
  const pending = getSpinnerState();
  const previouslyPending = usePrevious(pending);
  if (previouslyPending && !pending && appDetailsResult && marketplaceApp) {
    props.onRendered();
  }

  // effects

  useEffect(() => {
    if (marketplaceApp && installDialogOpenInitially) {
      openInstallDialog();
    }
  }, [marketplaceApp]);
  const renderAfterHeader = () => {
    if (!installedApp && appDetailsResult !== null && appDetailsResult !== void 0 && appDetailsResult.cloudMigrationTrial.isEligible) {
      return /*#__PURE__*/_jsx(CloudMigrationTrialMessage, {});
    }
    return null;
  };
  if (showAetherAppListingPage && pending) {
    return /*#__PURE__*/_jsx(AppListingPageSkeleton, {
      selectedHosting: AtlassianProductHostingType.Cloud,
      isEMCEE: true
    });
  }
  return /*#__PURE__*/_jsx(SpinnerMask, {
    active: pending,
    delay: 1000,
    size: 50,
    children: appDetailsResult && marketplaceApp ?
    /*#__PURE__*/
    _jsxs(MarketplaceAnalyticsContext, {
      attributes: analyticsContextAttributes,
      children: [/*#__PURE__*/_jsx(BreadcrumbsItem, {
        actionSubjectId: ANALYTICS_SUBJECT_ID_DISCOVER_APP_LISTING,
        onClick: handleBreadcrumbsItemClick,
        href: appListing.getRelative({
          appKey: props.appKey
        }),
        text: marketplaceApp.name,
        children: /*#__PURE__*/_jsxs(_Fragment, {
          children: [hostCmtEnabled && isEcosystemCloudApp && hasInstallPermission && /*#__PURE__*/_jsx(CloudMigrationTrialMessage, {
            isEcosystemCloudApp: isEcosystemCloudApp
          }), /*#__PURE__*/_jsx(AppListing, {
            links: props.links,
            appDetails: marketplaceApp,
            editions: editions,
            appDetailsFromSearchResponse: appDetailsFromSearchResponse,
            components: {
              afterHeader: renderAfterHeader()
            },
            user: appListingUser,
            cloudMigration: null,
            selectedTab: selectedTab,
            showIntegrationsDetailsSection: false,
            showResourcesSection: false,
            mpacBaseUrl: props.mpacBaseUrl,
            mpacCdnBaseUrl: applicationConfig.mpacCdnBaseUrl,
            feedbackCollectorApiKeys: isAetherExp ? applicationConfig.feedbackCollectorApiKeys : undefined,
            feedbackGatewayBaseUrl: isAetherExp ? applicationConfig.feedbackGatewayBaseUrl : undefined,
            atlassianCommunityBaseUrl: props.atlassianCommunityBaseUrl,
            onTabSelect: handleTabSelect,
            showInstallationCount: true,
            loginHref: "/login?redirect=".concat(encodeURIComponent(window.location.href)),
            headerInjection: /*#__PURE__*/_jsx(HeaderInjection, _objectSpread({
              links: props.links,
              hostPricing: props.hostPricing,
              installedApp: installedApp,
              onInstallClick: openInstallDialog,
              installationInProgressAppKey: installationInProgressAppKey,
              hasInstallPermission: hasInstallPermission,
              featureFlags: props.featureFlags,
              appKey: marketplaceApp.appKey,
              appName: marketplaceApp.name,
              paymentModel: paymentModel,
              mpacBaseUrl: props.mpacBaseUrl,
              isRequestDialogOpen: !!requestDialogOpenInitially,
              eligibleForFreeOnSandbox: appDetailsResult.eligibleForFreeOnSandbox,
              cloudMigrationTrial: appDetailsResult.cloudMigrationTrial
            }, ecosystemCloudAppId && {
              ecosystemCloudAppId
            })),
            selectedHosting: AtlassianProductHostingType.Cloud
          }), /*#__PURE__*/_jsxs(ViewMoreOnMarketplaceLink, {
            target: "_blank",
            href: marketplaceAppLink,
            "data-testid": "app-listing__view-more-link",
            onClick: handleViewMoreOnMarketplaceLinkClick,
            children: ["View all info on marketplace", /*#__PURE__*/_jsx(OpenIcon, {
              size: "small"
            })]
          })]
        })
      }), installerElement]
    }) : /*#__PURE__*/_jsx(NotFoundComponent, {
      history: history,
      showAetherAppListingPage: showAetherAppListingPage
    })
  });
}
export default function DiscoverAppDetailsWrapper(props) {
  const {
    appKey
  } = props;
  if (!appKey) {
    // TODO: Add the commonized error page from MC-463
    return /*#__PURE__*/_jsx("div", {
      children: "An invalid app ID was provided"
    });
  } else {
    return /*#__PURE__*/_jsx(DiscoverAppDetails, _objectSpread(_objectSpread({}, props), {}, {
      appKey: appKey
    }));
  }
}